import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrClosing } from '../../../../../../../shared/types/modules/pqr';

export const usePqrSample = (closing?: PqrClosing) => {
    const formik = useFormik({
        initialValues: {
            auditObservations: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            auditObservations: closing?.auditObservations || '',
        });
    }, [closing]);

    return {
        formik,
    };
};
